import loadable from '../../utils/loadable';

export default loadable(() => import('./WelcomePage'));
export const GenericWelcome = loadable(() => import('./GenericWelcome'));